import * as React from "react";

import {
	Show,
	SimpleShowLayout,
	ShowProps,
	BooleanField,
	DateField,
	TextField,
	ReferenceField,
	FunctionField,
	ResourceContextProvider,
} from "react-admin";
import { DOCTOR_SALE_SHARE } from "../constants";
import labelsTranslation from "../translations/tranlation";
import { DOCTORSALE_TITLE_FIELD } from "../doctorSale/DoctorSaleTitle";

export const PatientShow = (props: ShowProps): React.ReactElement => {
	const formatUserRole = (role: string) => {
		if (role === "doctor_sale.doctor") {
			return "پزشک";
		} else if (role === "sport_coach.coach") {
			return "مربی";
		} else {
			return "test";
		}
	};
	return (
		<ResourceContextProvider value="Patient">
			<Show title={"کاربر"} {...props}>
				<SimpleShowLayout>
					<FunctionField
						label={"نام و نام خانوادگی"}
						render={(record: any) => `${record.firstName} ${record.lastName}`}
						sortable={false}
					/>
					<TextField label="موبایل" source="mobile" sortable={false} />
					<FunctionField
						label={"نام و نام خانوادگی ثبت کننده"}
						render={(record: any) => {
							return record.doctor
								? `${record.doctor.firstName} ${record.doctor.lastName}`
								: null;
						}}
						sortable={false}
					/>
					<TextField
						style={{
							whiteSpace: "pre-line",
						}}
						label={"توضیحات ثبت کننده"}
						source="doctorComment"
						sortable={false}
					/>
					<FunctionField
						label={"نقش ثبت کننده"}
						render={(record: any) => {
							return record.doctor
								? `${formatUserRole(record.doctor.role)}`
								: null;
						}}
						sortable={false}
					/>
					<TextField
						label="توضیحات اپراتور"
						source="saleRepresentativeComment"
					/>

					<BooleanField label="ارشیو" source="archived" />
					{/* <BooleanField label="Archived" source="archived" />
				<DateField source="createdAt" label="Created At" />
				<TextField label="Doctor" source="doctor" />
				<TextField label="Doctor Comment" source="doctorComment" />
				<TextField label="Doctor Id" source="doctorId" />
				<ReferenceField
					label="Doctor Sale"
					source="doctorsale.id"
					reference="DoctorSale"
				>
					<TextField source={DOCTORSALE_TITLE_FIELD} />
				</ReferenceField>
				<TextField label="First Name" source="firstName" />
				<TextField label="ID" source="id" />
				<TextField label="Last Name" source="lastName" />
				<TextField label="Mobile" source="mobile" />
				<TextField
					label="Sale Representative Comment"
					source="saleRepresentativeComment"
				/>
				<DateField source="updatedAt" label="Updated At" /> */}
				</SimpleShowLayout>
			</Show>
		</ResourceContextProvider>
	);
};
